module.exports = __webpack_public_path__ + "img/i-am-sergio-guzman.442e6fc9.png";